import {  Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-button-close',
  standalone: true,
  imports: [MatDialogModule,MatIconModule,MatButtonModule,MatDialogClose],
  template: `<button mat-stroked-button color="primary" [mat-dialog-close]="true" [disabled]="disabled" name="Cerrar">
  <mat-icon>close</mat-icon> Cerrar
</button>`,
  styleUrls: ['./button-close.component.css'],
})
export class ButtonCloseComponent {
  @Input() disabled! : any
}
